import { IButtonStyles, IComboBoxStyles, IDialogContentStyles, IDialogStyles, IStyle } from '@fluentui/react';

import { ITimeFilterStyles } from '../../components/TimeFilters/TimeFilters.styles';

export interface IAIUnitWorkspacePageStyles {
  root?: IStyle;
  dataSectionWrapper?: IStyle;
  aiUnitCell?: IStyle;
}

export const aiUnitWorkspaceStylesDefault = (): Partial<IAIUnitWorkspacePageStyles> => ({
  root: {
    width: '100%',
  },
  dataSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1rem',
  },
  aiUnitCell: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
  },
});

export const filterStyles = (): Partial<ITimeFilterStyles> => ({
  filterContainer: {
    marginLeft: 'auto',
    width: 'fit-content',
  },
});

export const workspaceComboboxStyles = (): Partial<IComboBoxStyles> => ({
  root: {
    width: 400,
  },
  optionsContainerWrapper: {
    maxHeight: 400,
    width: 400,
  },
});

export const dialogStyles = (): Partial<IDialogStyles> => ({
  main: {
    maxWidth: 600,
    width: 600,
    minHeight: 'auto',
  },
});

export const dialogContentStyls = (): Partial<IDialogContentStyles> => ({
  content: {
    overflowX: 'hidden',
  },
});

export const buttonIconStyles = (): Partial<IButtonStyles> => ({
  root: {
    border: 0,
    height: 20,
    minHeight: '',
    minWidth: 0,
    padding: 0,
  },
  rootFocused: {
    backgroundColor: 'transparent',
  },
  rootHovered: {
    backgroundColor: 'transparent',
  },
  rootPressed: {
    backgroundColor: 'transparent',
  },
});
